<template>
  <module-template :id="id" :name="name" cssClass='module-method' width="190px" height="166px">
    <template slot="moduleContent">
      <button type='button' class='module-circle module-circle-input' style='margin-top: 28px; left: 5px' :id="id+'-criteria'" @click="showModal('criteria')"></button>
      <span class='module-circle-span' style='margin-top: 26px; left: 22px' @click="showModal('criteria')">Criteria</span>

      <button type='button' class='module-circle module-circle-input' style='margin-top: 45px; left: 5px' :id="id+'-actions'" @click="showModal('actions')"></button>
      <span class='module-circle-span' style='margin-top: 43px; left: 22px' @click="showModal('actions')">Actions</span>

      <button type='button' class='module-circle module-circle-input' style='margin-top: 62px; left: 5px' :id="id+'-performanceTable'" @click="showModal('performanceTable')"></button>
      <span class='module-circle-span' style='margin-top: 60px; left: 22px' @click="showModal('performanceTable')">Performance Table</span>

      <button type='button' class='module-circle module-circle-input' style='margin-top: 79px; left: 5px' :id="id+'-referenceActions'" @click="showModal('referenceActions')"></button>
      <span class='module-circle-span' style='margin-top: 77px; left: 22px' @click="showModal('referenceActions')">Reference Actions</span>

      <button type='button' class='module-circle module-circle-input' style='margin-top: 96px; left: 5px' :id="id+'-functions'" @click="showModal('functions')"></button>
      <span class='module-circle-span' style='margin-top: 94px; left: 22px' @click="showModal('functions')">SD Functions</span>

      <button type='button' class='module-circle module-circle-input' style='margin-top: 113px; left: 5px' :id="id+'-weights'" @click="showModal('weights')"></button>
      <span class='module-circle-span' style='margin-top: 111px; left: 22px' @click="showModal('weights')">Weights</span>

      <button type='button' class='module-circle module-circle-input' style='margin-top: 130px; left: 5px' :id="id+'-interactionCoefficients'" @click="showModal('interactionCoefficients')"></button>
      <span class='module-circle-span' style='margin-top: 128px; left: 22px' @click="showModal('interactionCoefficients')">Interaction Coefficients</span>

      <button type='button' class='module-circle module-circle-input' style='margin-top: 147px; left: 5px' :id="id+'-likenessThresholds'" @click="showModal('likenessThresholds')"></button>
      <span class='module-circle-span' style='margin-top: 145px; left: 22px' @click="showModal('likenessThresholds')">Likeness Thresholds</span>
    </template>
  </module-template>
</template>

<script>
import {EventBus} from '@/event-bus.js'
import ModuleTemplate from '@/components/Workspace/Methods/ModuleTemplate'
export default {
  components: {
    ModuleTemplate
  },
  props: {
    id: String,
    name: String
  },
  methods: {
    showModal(tab) {
      EventBus.$emit('show-modal-'+this.id, tab);
    }
  },
  mounted: function () {
    var endpoints = [
      {id: this.id+'-criteria', isSource: false},
      {id: this.id+'-actions', isSource: false},
      {id: this.id+'-performanceTable', isSource: false},
      {id: this.id+'-referenceActions', isSource: false},
      {id: this.id+'-functions', isSource: false},
      {id: this.id+'-weights', isSource: false},
      {id: this.id+'-interactionCoefficients', isSource: false},
      {id: this.id+'-likenessThresholds', isSource: false},
      {id: this.id+'-output', isSource: true}
    ];
    EventBus.$emit('add-endpoints', {id: this.id, endpoints: endpoints});
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Workspace/Methods/CATSDModule.vue